const cipaCards = [
  {
    id: 1,
    foto: '../../assets/img/cipa/2581-0.jpg',
    nome: 'BARBARA TALITA BERNARDO NEGREIRO',
    lotacao: 'MMF Coronel Leôncio',
    funcao: 'Técnica de Enfermagem'
  },
  {
    id: 2,
    foto: '../../assets/img/cipa/2105-9.jpg',
    nome: 'CONCEIÇÃO IGNACIO DA SILVA DELPHINO',
    lotacao: 'MMF Sapê',
    funcao: 'Técnica de Enfermagem'
  },
  {
    id: 3,
    foto: '../../assets/img/cipa/1948-8.jpg',
    nome: 'ELIZABETH MICHELLE MACEDO AMARAL DE OLIVEIRA',
    lotacao: 'MMF Badu',
    funcao: 'Agente Comunitário de Saúde'
  },
  {
    id: 4,
    foto: '../../assets/img/cipa/1269-6.jpg',
    nome: 'GABRIELLY MORENO DA SILVA',
    lotacao: 'MMF Souza Soares',
    funcao: 'Enfermeiro'
  },
  {
    id: 5,
    foto: '../../assets/img/cipa/2125-3.jpg',
    nome: 'GUILHERME MARTINS GUIMARÃES',
    lotacao: 'MMF Atalaia',
    funcao: 'Assistente Administrativo'
  },
  {
    id: 6,
    foto: '../../assets/img/cipa/2455-4.jpg',
    nome: 'IZIS SOUZA DE MOURA ALVES',
    lotacao: 'MMF Engenho do Mato',
    funcao: 'Assistente Administrativo'
  },
  {
    id: 7,
    foto: '../../assets/img/cipa/1307-2.jpg',
    nome: 'LEANDRO FONSECA DA COSTA',
    lotacao: 'MMF Ilha da Conceição',
    funcao: 'Assistente Administrativo'
  },
  {
    id: 8,
    foto: '../../assets/img/cipa/1972-0.jpg',
    nome: 'MARIA APARECIDA FAUSTINO ERNANDI',
    lotacao: 'CAPS Casa do Largo',
    funcao: 'Técnica de Enfermagem'
  },
  {
    id: 9,
    foto: '../../assets/img/cipa/1809-0.jpg',
    nome: 'MARIA LUIZA VENANCIO PETRUCCI DA FONSECA',
    lotacao: 'CAPS Casa do Largo',
    funcao: 'Musicoterapeuta'
  },
  {
    id: 10,
    foto: '../../assets/img/cipa/2165-2.jpg',
    nome: 'PATRICIA MARTINS AUGUSTO DIAS',
    lotacao: 'MMF Cafubá I',
    funcao: 'Assistente Administrativo'
  },
  {
    id: 11,
    foto: '../../assets/img/cipa/1802-3.jpeg',
    nome: 'THAIS PRADO DIAS',
    lotacao: 'MMF Vila Ipiranga',
    funcao: 'Agente Comunitário de Saúde'
  },
  {
    id: 12,
    foto: '../../assets/img/cipa/1556-3.jpg',
    nome: 'WILDE LANDEIRO DOS SANTOS',
    lotacao: 'MMF Teixeira de Freitas',
    funcao: 'Fisioterapeuta'
  },
  {
    id: 13,
    foto: '../../assets/img/cipa/1466-4.jpeg',
    nome: 'SIMONE DA CONCEIÇÃO OLIVEIRA',
    lotacao: 'MMF Baldeador',
    funcao: 'Técnica de Enfermagem'
  },
  {
    id: 14,
    foto: '../../assets/img/cipa/1225-4.jpg',
    nome: 'MARCIO SILVA COSTA',
    lotacao: 'CAPS AD III Alcenir Veras',
    funcao: 'Enfermeiro'
  },
  {
    id: 15,
    foto: '../../assets/img/cipa/1239-4.jpg',
    nome: 'PEDRO PAULO CORREA SANTANA',
    lotacao: 'MMF Alarico',
    funcao: 'Enfermeiro'
  },
  {
    id: 16,
    foto: '../../assets/img/cipa/1698-5.jpg',
    nome: 'JOYCE ELOISA E SILVA',
    lotacao: 'MMF Leopoldina',
    funcao: 'Agente Comunitário de Saúde'
  },
];

export default cipaCards;
